export default "__VITE_ASSET__DnNej8Nr__"